/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import isNil from 'lodash.isnil';
import {getSubAccount} from '@ion/core/src/entities/Accounts';
import {translate} from '@ion/core/src/locale/locale';
import {GeofenceFilter} from '@ion/dls/src/filters/GeofenceFilter';
import {Filters} from '@ion/dls/src/types/types';
import {hasLandmarkGeofenceAccess} from '../../../security/Features';
import {FilterParamsType} from '../types';

interface GeofencesFilterParamsType extends FilterParamsType {
  filterRefresh?: boolean;
};

export const GeofencesFilter = ({
  isPhone,
  accountHierarchy,
  globalGroupId,
  toggleView,
  filterState,
  handleSubmit,
  handleAction,
  ancestorAccountIds,
  descendantAccountId,
  filterRefresh
}: GeofencesFilterParamsType) => {
  const isGeofenceAccess = hasLandmarkGeofenceAccess();
  if (!isNil(accountHierarchy) && !isNil(globalGroupId)) {
    return (
      <GeofenceFilter isMobileView={isPhone}
        name={Filters.geoFences}
        filterRefresh={filterRefresh}
        account={globalGroupId}
        accountIds={getSubAccount(accountHierarchy?.[0], [globalGroupId])}
        filterState={filterState[Filters.geoFences]}
        actionLabel={isGeofenceAccess ? translate('tracking:filters.createGeofence') : null}
        onActionClick={handleAction}
        onCancel={toggleView}
        onMenuClose={toggleView}
        onSubmit={handleSubmit}
        ancestorAccountIds={ancestorAccountIds}
        descendantAccountId={descendantAccountId} />
    );
  }
  return null;
};

export default GeofencesFilter;
